import { DOMAINS } from '../data/domains';
import ImgSlot from './ui/ImgSlot';

interface BusinessProps {
  gray?: boolean;
}

export default function Business({ gray }: BusinessProps) {
  return (
    <section
      id="business"
      className={'section ' + (gray ? 'section--gray' : 'section--paper')}
    >
      <div className="container">
        <div className="section-head">
          <div>
            <div className="eyebrow">
              <span className="bar" />
              <span>Business Domains</span>
            </div>
            <h2 className="h2">
              Four domains.
              <br />
              One thesis.
            </h2>
          </div>
          <p className="lede">
            Mystar Engineering Group operates across two umbrellas — Mechatronics for
            Japan's manufacturers, and Critical Infrastructure for the systems society
            can't afford to stop. Within them, four operating domains compound one
            another.
          </p>
        </div>

        <div className="umbrella-block is-mecha">
          <div className="umbrella is-mecha">
            <div className="ko">MECHATRONICS</div>
          </div>
          <div className="domain-grid">
            {DOMAINS.filter((d) => d.umb === 'mecha').map((d, i) => (
              <div className="dom-card is-mecha" key={i}>
                <ImgSlot
                  ratio="16/10"
                  src={d.img}
                  alt={d.name}
                  style={{ borderBottom: '1px solid var(--line)' }}
                />
                <div className="body">
                  <div className="tag">{d.umbLabel}</div>
                  <h3 className="h3">{d.name}</h3>
                  <p>{d.blurb}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="umbrella-block">
          <div className="umbrella">
            <div className="ko">CRITICAL INFRASTRUCTURE</div>
          </div>
          <div className="domain-grid">
            {DOMAINS.filter((d) => d.umb === 'infra').map((d, i) => (
              <div className="dom-card is-infra" key={i}>
                <ImgSlot
                  ratio="16/10"
                  src={d.img}
                  alt={d.name}
                  style={{ borderBottom: '1px solid var(--line)' }}
                />
                <div className="body">
                  <div className="tag">{d.umbLabel}</div>
                  <h3 className="h3">{d.name}</h3>
                  <p>{d.blurb}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
